import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'app-dialog-generating-spinner',
  templateUrl: './dialog-generating-spinner.component.html',
  styleUrls: ['./dialog-generating-spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DialogGeneratingSpinnerComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() showNav: boolean;

  constructor(private trackingService: TrackingService) {}

  ngOnInit(): void {
    this.trackingService.trackActivity('[Modal] Generating strategy spinner open');
  }

  ngOnDestroy(): void {
    this.trackingService.trackActivity('[Modal] Generating strategy spinner closed');
  }
}
